function getNumberOfPages(recordCount, limit) {
    return Math.ceil(recordCount / limit);
}
export { getNumberOfPages, };
//# sourceMappingURL=paginator-utils.js.map